import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';


export const initialValues = { isModalOpen: false, open: modalProps => { }, close: () => { }, modalProps: {} };
export const EmailSignupContext = createContext(initialValues);

export const EmailSignupProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalProps, setModalProps] = useState({});

  const open = modalProps => {
    setIsModalOpen(true);
    setModalProps(modalProps);
  };

  const close = () => {
    setIsModalOpen(false);
    setModalProps({});
  };

  return (
    <EmailSignupContext.Provider value={{ isModalOpen, open, close, modalProps }}>
      {children}
    </EmailSignupContext.Provider>
  );
};
EmailSignupProvider.propTypes = {
  children: PropTypes.any
};
export const useEmailSignup = () => useContext(EmailSignupContext);
